<template>
    <div>
        <div class="col-md-12">
        <!-- <ob-button type="primary" @click="openempchecklistForm">Start</ob-button> -->
        </div>
        <div class="h1b-container pT0">
            <div class="h1b-title" >
                <div class="text-left pull-left">
                    <h4 style="font-weight: 600;color:#143361;">H-1B Files</h4>
                </div>
                <div class="clearfix"></div>
            </div>

            <ob-spinner v-if="loaderRes" loading-text="Loading..." ></ob-spinner>
            <div v-for="(data,index) in h1bEssData" v-bind:key="index">
                <div class="docs-top-border"></div>
                <single-H1B :H1BDetails="data"></single-H1B>
            </div>             
        </div>

            <div v-if="emptySection && !loaderRes" style="height: 400px;display:table;width:100%;">
                <div class="pfa-body" style="display: table-cell; vertical-align: middle;text-align: center;">
                    <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/Folder_icon.svg`" style="margin-bottom:20px;" /> 
                    <h5 class="pfa-info_msg">
                       Once the employer initiates the H-1B petition, it will be reflected here along with certified LCA if uploaded.
                    </h5>
                </div>
            </div> 
    </div>

</template>

<script>
     import c from 'Vue/Core/constants.js';
    import EmpH1BSingle from './EmpH1B/EmpH1BSingle.vue'
    export default {
        data() {
            return {

                ExpandFolder: true,
                emptySection: true,
                loaderRes: true,
                h1bData: '',
                fileUploadUrl:'',
                h1bEssData:[],
                expantMode:false
            }
        },
        created(){
            this.getH1BDetails()
            this.ExpandFolder = this.expantModee
        },        
        components:{
        "single-H1B":EmpH1BSingle,
        },
        methods:{
            openempchecklistForm(){
                var from = this.$route.name;
                this.$router.push({name: 'H1BPetitionEmpChecklistDocs', query: { from: from }})
            },
            getH1BDetails(){
                //if(loggedInUserObj.HireType == 'W2'){
                    ajax.get(`H1B/GetESSH1BDetails?consultantId=${loggedInUserObj.consultantId}&orgId=${loggedInUserObj.orgId}`,{},res => {
                        if(res.data.State == true){
                            this.h1bData = res.data.ESSH1BDetailsViewModel
                            if (this.h1bData.length === 0) {
                            this.loaderRes = false
                            this.emptySection = true   
                            return
                        }
                                this.h1bData.forEach((e)=>{   
                                    if(e.Document != null && e.ReviewerInfo != null){
                                            var h1b = {
                                                h1bId:e.H1BId,
                                                h1BType:'',
                                                h1BStatus:'',
                                                lcaData : e.LCA,
                                                documentLCA:'',
                                                documentI129:'',
                                                documentI129Signed: '',
                                                documentI539: '',
                                                documentI539A:[],
                                                documentI797: '',
                                                documentI797C: '',
                                                CourierDocuments: [],
                                                PetitionerDocuments: [],
                                                CurrentWorkAuthDocuments:  [],
                                                BeneficiaryDocuments: [],
                                                RTCDocuments: [],
                                                ClientDocuments: [],
                                                RFEDocuments: [],
                                                documentComplete: '',
                                                OtherDocuments: '',
                                                workloc: e.LCA && e.LCA.EmployeeWorkLocations ? e.LCA.EmployeeWorkLocations : '' ,
                                                h1bStartDate: '',
                                                h1bEndDate: '',
                                                isH1BPetitionDocumentsRequested:e.IsH1BPetitionDocumentsRequested,
                                                isPremiumPetition:e.IsPremiumPetition,
                                                petitionFiledByEmail:e.PetitionFiledByEmail,
                                                petitionFiledByName:e.PetitionFiledByName,
                                                petitionIniatedDate:e.PetitionIniatedDate,
                                                petitionType:e.PetitionType,
                                                PremiumPetitionIniatedDate:e.PremiumPetitionIniatedDate,
                                                submittedDate:e.submittedDate,
                                                comments:e.Comments,
                                                essDocumentStatus:e.ESSDocumentStatus,
                                                reviewedBy:e.ReviewerInfo.ReviewedBy,
                                                reviewedDate:e.ReviewerInfo.ReviewedDate,
                                                reviewerTabComments:e.ReviewerInfo.ReviewerTabComments,
                                                ReviewerInformation : e.ReviewerInformation,
                                                 CheckListPreviewInfo : e.CheckListPreviewInfo,
                                                CheckListPreviewPDFURL : e.CheckListPreviewPDFURL,
                                                IsShowReviewButton : e.IsShowReviewButton,
                                                IsHRManager : e.IsHRManager
                                                
                                            }; 
                                            // if(e.ESSH1BCheckList != null && e.ESSH1BCheckList.RequestId != null) {
                                            //     h1b.essDocumentStatus=e.ESSH1BCheckList.ESSDocumentStatus
                                            //     h1b.reviewedBy=e.ESSH1BCheckList.ReviewerInfo.ReviewedBy
                                            //     h1b.reviewedDate=e.ESSH1BCheckList.ReviewerInfo.ReviewedDate
                                            //     h1b.reviewerTabComments=e.ESSH1BCheckList.ReviewerInfo.ReviewerTabComments
                                            //     h1b.ReviewerInformation = e.ESSH1BCheckList.ReviewerInformation
                                            //     h1b.CheckListPreviewInfo = e.ESSH1BCheckList.CheckListPreviewInfo
                                            //     h1b.CheckListPreviewPDFURL = e.ESSH1BCheckList.CheckListPreviewPDFURL
                                            //     h1b.IsShowReviewButton = e.ESSH1BCheckList.IsShowReviewButton
                                            //     h1b.IsHRManager = e.ESSH1BCheckList.IsHRManager
                                            //     h1b.RequestId = e.ESSH1BCheckList.RequestId
                                            // }
                                            h1b.h1BType = e.H1BType 
                                            h1b.h1BStatus = e.H1BStatus  
                                            h1b.PetitionFiledDate = e.PetitionFiledDate  
                                            h1b.StartDate = e.StartDate  
                                            h1b.EndDate = e.EndDate  
                                            h1b.ReceiptNumber = e.ReceiptNumber  
                                            h1b.ApprovedDocType = e.ApprovedDocType  

                                            if(e.Document.ESSH1BDocuments){
                                                if(e.Document.ESSH1BDocuments.CertifiedLCA != null)
                                                    h1b.documentLCA = e.Document.ESSH1BDocuments.CertifiedLCA
                                                if(e.Document.ESSH1BDocuments.FormI129 != null)
                                                    h1b.documentI129 = e.Document.ESSH1BDocuments.FormI129
                                                if(e.Document.ESSH1BDocuments.SignedFormI129 != null)
                                                    h1b.documentI129Signed = e.Document.ESSH1BDocuments.SignedFormI129
                                                if(e.Document.ESSH1BDocuments.FormI539 != null)
                                                    h1b.documentI539 = e.Document.ESSH1BDocuments.FormI539
                                                if(e.Document.ESSH1BDocuments.FormI539A != null)
                                                    h1b.documentI539A = e.Document.ESSH1BDocuments.FormI539A

                                                if(e.Document.ESSH1BDocuments.I797){
                                                    h1b.documentI797 = e.Document.ESSH1BDocuments.I797
                                                    if(h1b.documentI797.MetadataValues != null && h1b.documentI797.MetadataValues.length > 0){
                                                        let I797MetadataValues = []
                                                        I797MetadataValues.push(h1b.documentI797.MetadataValues[h1b.documentI797.MetadataValues.length - 1])
                                                        h1b.documentI797.MetadataValues = I797MetadataValues
                                                        let data = h1b.documentI797.MetadataValues[0].DocumentData
                                                            data.forEach((m) =>{
                                                                if(m.Key == 'IssueDate'){
                                                                    h1b.h1bStartDate = m.Value
                                                                }
                                                                if(m.Key == 'ExpiryDate'){
                                                                    h1b.h1bEndDate = m.Value
                                                                }
                                                            })  
                                                    }
                                                }

                                                if(e.Document.ESSH1BDocuments.I797C){
                                                    h1b.documentI797C = e.Document.ESSH1BDocuments.I797C
                                                    if(h1b.documentI797C.MetadataValues && h1b.documentI797C.MetadataValues.length > 0){
                                                        let I797CMetadataValues = []
                                                        I797CMetadataValues.push(h1b.documentI797C.MetadataValues[h1b.documentI797C.MetadataValues.length - 1])
                                                        h1b.documentI797C.MetadataValues = I797CMetadataValues
                                                    }
                                                }
                                                if(e.Document.ESSH1BDocuments.CourierDocuments){
                                                    let courierDocs = []
                                                    let courierFields = []  
                                                    let doc1 = '' 
                                                    let doc2 = '' 
                                                    let doc3 = ''

                                                    if(e.Document.ESSH1BDocuments.CourierDocuments.some(c => c.DocumentType == "CourierReciept")){
                                                        let courierReceipt = e.Document.ESSH1BDocuments.CourierDocuments.find(c => c.DocumentType == "CourierReciept")
                                                        
                                                        if(courierReceipt.MetadataValues && courierReceipt.MetadataValues.length > 0 && courierReceipt.MetadataValues[0].DocumentData && courierReceipt.MetadataValues[0].DocumentData.length > 0){
                                                            courierFields = courierReceipt.MetadataValues[0].DocumentData.filter(x => x.Key != "DocumentUrl")

                                                            if(courierReceipt.MetadataValues[0].DocumentData.some(x => x.Key == "DocumentUrl" && x.Value)){
                                                                courierReceipt.MetadataValues[0].DocumentData = courierReceipt.MetadataValues[0].DocumentData.filter(x => x.Key == "DocumentUrl")
                                                                doc1 = courierReceipt
                                                            }
                                                        }
                                                    }

                                                    if(e.Document.ESSH1BDocuments.CourierDocuments.some(c => c.DocumentType == "FormI129FeeReceipt")){
                                                        let paymentProof = e.Document.ESSH1BDocuments.CourierDocuments.find(c => c.DocumentType == "FormI129FeeReceipt")

                                                        if(paymentProof.MetadataValues && paymentProof.MetadataValues.length > 0 && paymentProof.MetadataValues[0].DocumentData && paymentProof.MetadataValues[0].DocumentData.length > 0 
                                                            && paymentProof.MetadataValues[0].DocumentData.some(x => x.Key == "DocumentUrl" && x.Value)){
                                                            paymentProof.MetadataValues[0].DocumentData = paymentProof.MetadataValues[0].DocumentData.filter(x => x.Key == "DocumentUrl")
                                                            doc2 = paymentProof
                                                        }
                                                    }
                                                    
                                                    if(e.Document.ESSH1BDocuments.CourierDocuments.some(c => c.DocumentType == "FormI129ReceiptNotice")){
                                                        let receiptNotice = e.Document.ESSH1BDocuments.CourierDocuments.find(c => c.DocumentType == "FormI129ReceiptNotice")

                                                        if(receiptNotice.MetadataValues && receiptNotice.MetadataValues.length > 0 && receiptNotice.MetadataValues[0].DocumentData && receiptNotice.MetadataValues[0].DocumentData.length > 0
                                                            && receiptNotice.MetadataValues[0].DocumentData.some(x => x.Key == "DocumentUrl" && x.Value)){
                                                            receiptNotice.MetadataValues[0].DocumentData = receiptNotice.MetadataValues[0].DocumentData.filter(x => x.Key == "DocumentUrl")
                                                            doc3 = receiptNotice
                                                        }
                                                    }

                                                    if(doc3){
                                                        courierDocs.push(doc3)
                                                    }
                                                    if(doc2){
                                                        courierDocs.push(doc2)
                                                    }
                                                    if(doc1){
                                                        courierDocs.push(doc1)
                                                    }

                                                    h1b.CourierDocuments = courierDocs
                                                    h1b.CourierFields = courierFields
                                                }
                                                h1b.PetitionerDocuments = e.Document.ESSH1BDocuments.PetitionerDocuments
                                                h1b.CurrentWorkAuthDocuments = e.Document.ESSH1BDocuments.CurrentWorkAuthDocuments
                                                h1b.BeneficiaryDocuments = e.Document.ESSH1BDocuments.BeneficiaryDocuments
                                                h1b.RTCDocuments = e.Document.ESSH1BDocuments.RTCDocuments
                                                h1b.ClientDocuments = e.Document.ESSH1BDocuments.ClientDocuments
                                                h1b.RFEDocuments = e.Document.ESSH1BDocuments.RFEDocuments

                                                if(e.Document.ESSH1BDocuments.CompletePackate){
                                                    h1b.documentComplete = e.Document.ESSH1BDocuments.CompletePackate
                                                }
                                                if(e.Document.ESSH1BDocuments.OtherDocuments){
                                                    h1b.OtherDocuments = e.Document.ESSH1BDocuments.OtherDocuments
                                                }
                                            }
                                            
                                            if(e.LCA && e.LCA.EmployeeWorkLocations){
                                                h1b.workloc = e.LCA.EmployeeWorkLocations 
                                            }   
                                            if(this.$route.params.H1BId && this.$route.params.H1BId == e.H1BId)  
                                            {
                                                h1b.isExpand = true
                                            } 
                                            else{
                                                h1b.isExpand = false
                                            }          
                                            this.h1bEssData.push(h1b);  
                                    }
                                })  
                            this.loaderRes = false
                            this.emptySection = false
                        }
                        else{
                        this.loaderRes = false
                        this.ESSEnableDisable(res)
                        }               
                    })
               // }
            },
            
        }
    }
</script>

<style lang="scss" scoped>

    @import "~styles/framework/vue-utils";
    .h1b-container {
        padding:15px;
    }

    .h1b-title {
       //border-bottom:1px dashed #ccc;
       //margin:10px 0;
       //padding:10px 0;
        margin: 20px 0 -10px 0;
       h3{
             font-weight:600;
             color:#143361;
         }
    }
    .pfa-body {
        padding: 15px;
        display: inline-block;
        .pfa-info_msg {
                color: $ob-brand-primary;
                font-size: 13px;
                line-height: 20px;
                margin: 0;
        }

    }       
    .docs-top-border{
        border-top: dashed 1.4px #b5b5b5;
        margin: 20px 0;

    }
</style>


// WEBPACK FOOTER //
// src/components/ESSProfile/EmpH1B.vue